import { render } from "./ScienceDeptView.vue?vue&type=template&id=11d61cbf"
import script from "./ScienceDeptView.vue?vue&type=script&lang=js"
export * from "./ScienceDeptView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__